import { useState } from 'react';
import { Image as ImageIcon, Music as MusicIcon } from 'lucide-react';
import { MediaManager, MusicManager } from './MediaManagers';

/**
 * Casa de Candy — Library tab.
 *
 * Consolidates the previous "Media" and "Music" admin tabs into a single
 * Library surface with a lightweight inline toggle. Each sub-view simply
 * renders the existing manager component, so upload UIs and APIs stay
 * untouched (zero regression risk).
 */
export function LibraryPanel() {
  const [section, setSection] = useState('photos');

  return (
    <div data-testid="library-panel">
      <div className="mb-6 flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="font-heading text-xl font-semibold text-[#F4F2FF]">
            Library
          </h2>
          <p className="text-sm text-[#A7A3BA]">
            Photos, video, and background audio that powers the public
            carousel and the orientation soundscape.
          </p>
        </div>
        <div
          className="inline-flex items-center bg-[#111022] border border-white/5 rounded-full p-1"
          role="tablist"
          aria-label="Library section"
          data-testid="library-toggle"
        >
          <button
            type="button"
            role="tab"
            aria-selected={section === 'photos'}
            onClick={() => setSection('photos')}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              section === 'photos'
                ? 'bg-[#8B5CFF] text-white'
                : 'text-[#A7A3BA] hover:text-[#F4F2FF]'
            }`}
            data-testid="library-toggle-photos"
          >
            <ImageIcon className="w-4 h-4" />
            Photos &amp; Video
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={section === 'music'}
            onClick={() => setSection('music')}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              section === 'music'
                ? 'bg-[#27D7FF] text-[#07060B]'
                : 'text-[#A7A3BA] hover:text-[#F4F2FF]'
            }`}
            data-testid="library-toggle-music"
          >
            <MusicIcon className="w-4 h-4" />
            Music
          </button>
        </div>
      </div>

      <div role="tabpanel" data-testid={`library-section-${section}`}>
        {section === 'photos' ? <MediaManager /> : <MusicManager />}
      </div>
    </div>
  );
}

export default LibraryPanel;
